<template>
  <button class="ELYXToggleButton" @click="$emit('click')">
    <div class="ELYXToggleButton__background" :class="isEnabled ? 'ELYXToggleButton__background--active' : ''">
      <div class="ELYXToggleButton__circle" :class="isEnabled ? 'ELYXToggleButton__circle--active ' : ''"></div>
    </div>
  </button>
</template>
<script>
export default {
  props: {
    isEnabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style scoped>
.ELYXToggleButton {
  background-color: #e2e2e2ad;
  border: 1px solid transparent;
  border-radius: 360px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
  padding: 2px;
  cursor: pointer;
  transition: 0.1s ease;
}
.ELYXToggleButton:hover {
  border-color: #cecece80;
}
.ELYXToggleButton__background {
  height: 28px;
  margin: 0;
  padding: 0px 2px;
  border-radius: 360px;
  width: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.2s ease-in-out;
}
.ELYXToggleButton__background--active {
  background-color: #323333;
}
.ELYXToggleButton__circle {
  background-color: white;
  height: 25px;
  width: 25px;
  box-sizing: border-box;
  margin: 0;
  margin-right: auto;
  padding: 0px;
  border-radius: 360px;
  transition: 0.2s ease-in-out;
}
.ELYXToggleButton__circle--active {
  margin-right: unset;
  margin-left: auto;
}
</style>
